import { defineStore } from "pinia";
import {
  PATH_TO_PERMISSION,
  LICENSE_CHECKED_PARTS,
  NOT_PERMISSION_CHECKED_PARTS,
} from "../../_config/constants";
import { useSettingsStore } from "./settings";

export const useAuthUserStore = defineStore("authUser", {
  state: () => ({
    loaded: false,
    name: "",
    email: "",
    tier: "",
    kb_admin: false,
    rm_admin: false,
    preferences: {},
    permissions: {},
    eula_accepted_at: null,
    otp_required_for_login: false,
    session_id: null,
    person_id: null,
    id: null,
    role_ids: [],
    team_ids: [],
    owned_team_ids: [],
    provided_service_ids: [],
    avatar_id: null,
    category_id: null,
    impersonator: null,
  }),
  getters: {
    avatar: (state) => ({
      document_id: state.avatar_id,
      category_id: state.category_id,
    }),
    isImpersonated: (state) => !!state.impersonator,
    canSeeAppPart: (state) => {
      return (partId) => {
        if (!partId) return false;
        if (partId < 0) return true; // Not license-checked nor permission-checked

        let permitted = true;
        if (!NOT_PERMISSION_CHECKED_PARTS.includes(partId)) {
          permitted = state.permissions.parts?.includes(partId) || false;
        }

        let licensed = true;
        if (LICENSE_CHECKED_PARTS.includes(partId)) {
          const settingsStore = useSettingsStore();
          licensed = settingsStore.license_part_ids.includes(partId);
        }

        return permitted && licensed;
      };
    },
    canSeeAppPartByUrl: (state) => {
      return (partUrl) => {
        if (!partUrl) return true;

        return state.canSeeAppPart(PATH_TO_PERMISSION[partUrl]);
      };
    },
    canCreate: (state) => {
      return (model) => {
        return state.permissions.create.includes(model);
      };
    },
    canConfigure: (state) => {
      return (model) => {
        return state.permissions.configure.includes(model);
      };
    },
  },
  actions: {},
});
